import { useCallback, useEffect, useState } from "react";

export interface UseBatchSelectionResult {
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  clear: () => void;
}

export const useBatchSelection = (
  deps: ReadonlyArray<unknown> = []
): UseBatchSelectionResult => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const clear = useCallback(() => setSelectedIds([]), []);

  useEffect(() => {
    setSelectedIds([]);
    // We intentionally spread the consumer-provided deps into the effect's
    // dep array so the hook clears when any of those values change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { selectedIds, setSelectedIds, clear };
};
